import React from 'react';

import { useSubjectsQuery } from '@school_ify/schoolify-repository/src/shared/types';

import DropDown from 'clean/components/common/DropDown/DropDown';

import styles from './AssignmentSelect.module.scss';

interface Props {
  value: string; // assignment id
  onChange: (value: string) => void;
}
const AssignmentSelect: React.FC<Props> = ({ onChange, value }) => {
  const { data: subjects } = useSubjectsQuery();
  const options = (subjects?.subjects || []).map((option, index) => ({
    ...option,
    group: (() => {
      if (index < 3) {
        return 'Tests';
      }
      if (index < 5) {
        return 'Homework';
      }
      if (index < 7) {
        return 'Other';
      }
      return 'Quiz';
    })(),
  }));
  return (
    <DropDown
      value={value}
      onChange={onChange}
      labelProperty="name"
      groupProperty="group"
      emptyItemLabel="Choose an assignment"
      options={options}
      containerClassName={styles.dropDownContainer}
    />
  );
};

export default AssignmentSelect;
